import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { AuthorFilter } from '../../../../models/Filter';
import { SellerFilter } from '../../seller/SellerFilter';

interface IMobileSellerFilter {
    filter: AuthorFilter;
    handleChange: (filter: AuthorFilter) => void;
    classNameGroup?: string;
    isSecond?: boolean;
    isRentTitle?: boolean;
}

export const MobileSellerFilterButtonView: React.FC<IMobileSellerFilter> = ({
    filter,
    handleChange,
    classNameGroup,
    isSecond,
    isRentTitle = false
}) => {
    return (
        <MobileFilter2 filterTitle={isRentTitle ? 'Автор объявления' : 'Продавец'}>
            <SellerFilter
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
                isSecond={isSecond}
            />
        </MobileFilter2>
    );
};
